import { render, staticRenderFns } from "./Action_question.vue?vue&type=template&id=4bdfed74&scoped=true"
import script from "./Action_question.vue?vue&type=script&lang=js"
export * from "./Action_question.vue?vue&type=script&lang=js"
import style0 from "./Action_question.vue?vue&type=style&index=0&id=4bdfed74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdfed74",
  null
  
)

export default component.exports